
import React from 'react';
import { Label } from '@/components/ui/label';
import { SimplifiedRichTextEditor } from '@/components/ui/simplified-rich-text-editor';

interface DescriptionFieldProps {
  description: string;
  onDescriptionChange: (value: string) => void;
}

export function DescriptionField({
  description,
  onDescriptionChange
}: DescriptionFieldProps) {
  return (
    <div className="space-y-2">
      <Label htmlFor="description">Description</Label>
      <SimplifiedRichTextEditor
        value={description}
        onChange={onDescriptionChange}
        placeholder="Enter assessment description"
      />
    </div>
  );
}
